﻿export const proofValidator = (fieldName) => proofSuppliedIfNeeded();

export const proofSuppliedIfNeeded = (isRequired, isUpdated, attachments) => (
  fieldName,
  vm
) => {
  if (isRequired && isUpdated) {
    if (attachments) {
      return attachments.length > 0;
    }
    return false;
  }
  return true;
};
